import { componentComposition } from 'trait/composition'

const descriptor = 'G.Upload'

/**
 * Upload Component
 *
 */
export default componentComposition(descriptor)
